import { assert } from '@ember/debug';
import loadConfigFromMeta from '@embroider/config-meta-loader';
import type { EmberSentryConfig } from '@sentry/ember/types';

const config = loadConfigFromMeta('frontend-payments') as unknown;

assert(
  'config is not an object',
  typeof config === 'object' && config !== null,
);
assert(
  'modulePrefix was not detected on your config',
  'modulePrefix' in config && typeof config.modulePrefix === 'string',
);
assert(
  'locationType was not detected on your config',
  'locationType' in config && typeof config.locationType === 'string',
);
assert(
  'rootURL was not detected on your config',
  'rootURL' in config && typeof config.rootURL === 'string',
);
assert(
  'APP was not detected on your config',
  'APP' in config && typeof config.APP === 'object',
);

export default config as {
  APP: Record<string, unknown>;
  locationType: string;
  modulePrefix: string;
  podModulePrefix?: string;
  rootURL: string;
} & {
  '@sentry/ember': EmberSentryConfig;
  adyen: {
    environment: string;
    publicKey: string;
  };
  analytics: {
    apiHost: string;
    cdnURL: string;
    enableLogging: boolean;
    enabled: boolean;
    writeKey: string;
  };
  'browser-support-build': {
    staticURL: string;
  };
  'ember-simple-auth': {
    authenticationRoute: string;
    routeAfterAuthentication: string;
    routeIfAlreadyAuthenticated: string;
  };
  environment: string;
  'mixpanel-browser': {
    apiHost: string;
    token: string;
  };
  staticURL: string;
  usersnap: {
    enabled: boolean;
    spaceAPIKey: string;
  };
} & Record<string, unknown>;
